import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ATA.ALTERAR_FORNECEDOR.ALTERAR.RESET_ALTERAR_FORNCEDORES](state) {
		state.idFornecedor = null
		state.idPessoaNova = null
		state.justificativa = null
	},
}
